import { ISettings } from '../../../types';

/**
 * Blank-but-valid settings placeholder. Rendered for the brief window before
 * `useFetchSettings` resolves (cold react-query cache) so branding code can read
 * `settings.brand.*` without a null guard. Replaces the default that previously
 * lived in the retired `settingsCache.ts` global-var bridge.
 */
export const EMPTY_SETTINGS: ISettings = {
  entity_id: 0,
  previewUrl: '',
  advanced: { google_analytics_id: '' },
  brand: {
    logo: {
      header: '',
      footer: '',
      placement: {
        header_as_footer: false,
        header_only: false,
        unique_footer: false,
        footer_only: false
      }
    },
    colors: {
      header: {
        background: { swatch: [], active: '' },
        font: { swatch: [], active: '' }
      },
      body: {
        background: { swatch: [], active: '' },
        font: { swatch: [], active: '' }
      },
      footer: {
        background: { swatch: [], active: '' },
        font: { swatch: [], active: '' }
      }
    },
    fonts: { headline: '', paragraph: '' }
  }
};
